import { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import FlightItinerary from '../FlightItinerary';

const SelectedFlight = ({ tripId, onModalClose, isModalOpen }) => {
  const trip = useSelector((store) => store.trip.selectedTrips[tripId]);
  return trip && trip.flightItinerary
    ? (
      <>
        <div className="mt-10 mb-5 font-bold">
          Selected flight
        </div>
        <FlightItinerary
          key={trip.flightItinerary.flightKey}
          itinerary={trip.flightItinerary}
          tripId={tripId}
          onModalClose={onModalClose}
          isModalOpen={isModalOpen}
        />
      </>
    )
    : '';
};
SelectedFlight.propTypes = {
  tripId: PropTypes.string.isRequired,
  onModalClose: PropTypes.func,
  isModalOpen: PropTypes.bool.isRequired,
};
SelectedFlight.defaultProps = {
  onModalClose: undefined,
};
export default memo(SelectedFlight);
